// @flow

import React, { useMemo } from 'react';
import type { Element } from 'react';

import { faTimes } from '@fortawesome/free-solid-svg-icons';
import compact from 'lodash/compact';

import { withTranslation } from '@i18n';

import type { Props } from './types';

import {
  StyledCover, StyledFilter, StyledIcon, StyledContent, StyledTitle
} from './styles';

const Preview = ({
  values, className, onClear, t
}: Props): Element<any> => {
  const sanitizedValues: Array<string> = useMemo(
    () =>
      compact(
        values.map((value: ?string) => {
          const sanitized = value && value.length > 25 ? `${value.substring(0, 25)}...` : value;

          return sanitized;
        })
      ),
    [values]
  );

  return (
    <StyledCover className={className}>
      <StyledContent>
        <StyledTitle>{t('MobileFilters.Filters')}</StyledTitle>

        {sanitizedValues.map(value => (
          <StyledFilter key={value}>{value}</StyledFilter>
        ))}
      </StyledContent>

      <StyledIcon icon={faTimes} onClick={onClear} />
    </StyledCover>
  );
};

export default withTranslation('common')(Preview);
